var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path39, _rect9, _path40, _path41, _path42, _path43, _path44, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path45, _rect18, _path46, _path47, _path48, _path49, _path50, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 71,
    viewBox: "0 0 116 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4292 32.5886C62.0957 34.4395 57.8057 41.3745 56.3919 42.1839C54.9779 42.9933 44.8555 49.7705 44.8555 49.7705C44.8555 49.7705 45.5588 51.3572 46.0238 51.6921C47.8117 51.4015 57.0933 47.0197 58.9414 45.9107C60.7894 44.8018 68.013 35.092 68.013 35.092L63.4292 32.5886Z",
    fill: "url(#paint0_linear_3793_18422)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8724 57.9835C67.5551 57.9835 80.71 57.3503 80.71 57.3503L78.3018 78.7731L71.4954 79.2746L70.7789 72.4681L67.9848 79.2746L61.0352 78.2716C61.0352 78.2716 63.9748 62.2699 65.8724 57.9835Z",
    fill: "url(#paint1_linear_3793_18422)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4754 43.3576C81.4754 43.3576 84.0223 49.0423 84.0223 49.7245C84.0223 50.4067 82.6644 60.2771 82.3233 60.6183C81.641 61.0513 78.9257 62.1403 78.755 62.6063C78.5846 63.0725 78.937 63.4703 78.937 63.4703C78.1982 63.9478 76.2653 65.3916 76.6064 65.7327C76.8425 65.9688 77.0024 66.0524 77.0784 66.0814C77.1121 66.0942 77.1295 66.0965 77.1295 66.0965C77.1295 66.0965 76.6406 67.0174 77.5275 66.8922C77.6184 67.4151 78.0277 67.3585 78.3575 67.2107C78.6873 67.0629 79.0624 66.7674 79.0624 66.7674C79.0624 67.2563 79.3809 67.5178 80.0402 66.9721C80.6998 66.4263 81.8706 65.551 82.4277 65.0961C82.9848 64.6414 84.0082 62.39 84.3606 61.56C84.7131 60.73 86.9901 53.8906 87.3995 52.4101C87.8088 50.9293 88.343 50.3204 87.9339 48.9081C87.5246 47.4958 85.4326 41.4927 85.4326 41.4927L81.4754 43.3576Z",
    fill: "url(#paint2_linear_3793_18422)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1308 63.6293C79.0817 63.6293 79.0324 63.622 78.9836 63.6051C78.8511 63.559 78.7409 63.4435 78.6817 63.2869C78.6324 63.1562 78.6228 63.0208 78.6135 62.8899C78.6102 62.8438 78.645 62.804 78.691 62.8008C78.7338 62.7927 78.7769 62.832 78.7801 62.8781C78.7887 62.9971 78.7973 63.12 78.8381 63.228C78.8791 63.3362 78.9541 63.4183 79.0382 63.4475C79.15 63.4858 79.2824 63.442 79.4095 63.3886C79.7657 63.2391 80.1028 63.0457 80.4117 62.8144C80.4485 62.7874 80.5008 62.7937 80.5285 62.8312C80.5562 62.868 80.5487 62.9203 80.5117 62.948C80.1919 63.1874 79.843 63.3873 79.4745 63.5424C79.3634 63.589 79.2474 63.6293 79.1308 63.6293Z",
    fill: "#E07E58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1459 66.1497C77.1363 66.1497 77.1267 66.1494 77.1169 66.1484C76.9495 66.1323 76.7934 66.0127 76.7197 65.8433C76.6593 65.7041 76.6515 65.5327 76.698 65.3602C76.7101 65.3159 76.7557 65.2897 76.8002 65.3016C76.8448 65.3136 76.8712 65.3592 76.8591 65.404C76.8226 65.54 76.8274 65.6724 76.8727 65.7771C76.9221 65.8899 77.0266 65.9725 77.1328 65.9825C77.228 65.9891 77.3422 65.8949 77.4351 65.8171L77.7262 65.5818C78.3397 65.0878 78.7832 64.7309 79.3809 64.1861C79.4149 64.1551 79.468 64.1574 79.4987 64.1916C79.5299 64.2256 79.5274 64.2785 79.4934 64.3094C78.892 64.8577 78.4237 65.2348 77.8309 65.7117L77.5421 65.9455C77.4324 66.0364 77.2969 66.1497 77.1459 66.1497Z",
    fill: "#E07E58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4374 66.9541C77.2997 66.9541 77.1725 66.9043 77.0884 66.8124C76.9142 66.6213 76.9694 66.3341 77.0786 66.1286C77.1005 66.0881 77.1514 66.0735 77.1916 66.0944C77.2324 66.1163 77.2478 66.1666 77.2261 66.2074C77.1473 66.3552 77.0962 66.5725 77.2118 66.6998C77.2986 66.7947 77.4514 66.8023 77.565 66.7676C77.6959 66.7278 77.8109 66.6392 77.9368 66.5365C78.5805 66.0095 79.2021 65.4338 79.803 64.877L79.9216 64.9948C79.3136 65.5582 78.69 66.1359 78.0425 66.6656C77.9026 66.7801 77.7737 66.8786 77.6136 66.9274C77.5544 66.9453 77.4948 66.9541 77.4374 66.9541Z",
    fill: "#E07E58"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9528 67.3499C77.9224 67.3499 77.8919 67.3476 77.8612 67.3428C77.7036 67.3166 77.5332 67.1948 77.5123 67.0123C77.507 66.9667 77.54 66.9252 77.5858 66.9199C77.6286 66.9143 77.6729 66.9473 77.6782 66.9931C77.6895 67.0923 77.795 67.1623 77.8881 67.1777C78.0077 67.1983 78.1341 67.1568 78.2416 67.1147C78.6001 66.9743 78.9465 66.7467 79.3009 66.4184C79.4673 66.2646 79.6549 66.1279 79.8538 65.9831C80.0491 65.8409 80.2513 65.6944 80.4683 65.5073C80.5035 65.4771 80.5561 65.4812 80.5858 65.5162C80.616 65.5511 80.612 65.6038 80.577 65.6337C80.3547 65.8248 80.1405 65.9806 79.9517 66.1178C79.7571 66.2596 79.5731 66.3932 79.4142 66.5408C79.0444 66.8834 78.6806 67.1218 78.3025 67.2698C78.1985 67.3108 78.0787 67.3499 77.9528 67.3499Z",
    fill: "#E07E58"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4151 67.2921C79.3847 67.2921 79.3542 67.2881 79.3237 67.2793C79.1402 67.2272 79.0589 67.0406 79.0038 66.8649C78.9902 66.8208 79.0146 66.774 79.0586 66.7602C79.1029 66.7468 79.1495 66.771 79.1634 66.8145C79.2052 66.948 79.2623 67.0882 79.3695 67.1187C79.4511 67.1416 79.5458 67.0978 79.6366 67.0472C80.1011 66.7886 80.516 66.4394 80.9173 66.1013L81.5111 65.6016C81.5466 65.5722 81.5995 65.577 81.629 65.6117C81.6587 65.647 81.6541 65.6998 81.6189 65.7293L81.025 66.229C80.6177 66.5721 80.1965 66.9268 79.7177 67.1932C79.6263 67.2438 79.5226 67.2921 79.4151 67.2921Z",
    fill: "#E07E58"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3962 28.7258C68.2191 28.9169 65.3139 29.6716 62.9495 32.036C60.5851 34.4004 59.1094 37.8055 58.6797 39.2863C58.6797 39.2863 61.3384 42.0187 62.8191 42.0187L65.8157 39.3918C65.3857 42.7352 65.0906 57.9169 65.2817 59.5888C65.2817 59.5888 77.9956 58.3064 80.6704 58.7839C81.0047 56.2524 79.4285 39.965 79.4285 39.965L81.1958 43.9773C81.1958 43.9773 85.1603 43.2608 85.8289 41.8757C86.1632 39.822 83.7512 33.9231 81.9601 32.1319C80.1689 30.3408 75.4739 29.1082 75.4739 29.1082C75.2103 29.3721 74.1691 30.4362 72.2281 30.4362C71.3032 30.4359 70.5444 29.3192 70.3962 28.7258Z",
    fill: "#098D83"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6642 44.3243C65.663 44.3243 65.662 44.3243 65.6607 44.3243C65.5915 44.3222 65.5371 44.2646 65.5391 44.1954L65.6302 41.0105C65.6448 40.5083 65.6592 40.0048 65.6889 39.5091C65.7617 38.2904 65.9291 37.0675 66.1864 35.8739C66.201 35.8065 66.2679 35.7642 66.3351 35.778C66.4026 35.7926 66.4457 35.8593 66.431 35.9268C66.1763 37.108 66.0109 38.3184 65.9386 39.5242C65.9089 40.0159 65.8946 40.5174 65.8807 41.0022L65.7894 44.2024C65.7873 44.2704 65.7317 44.3243 65.6642 44.3243Z",
    fill: "#C16810"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3749 44.0936C81.3296 44.0936 81.2858 44.0692 81.2636 44.0261C80.1597 41.9031 79.1983 39.682 78.4055 37.4241C78.3826 37.3589 78.4169 37.2874 78.4823 37.2645C78.5473 37.2421 78.619 37.2758 78.6419 37.3413C79.4307 39.5878 80.3875 41.7979 81.4856 43.9106C81.5176 43.9717 81.4937 44.0475 81.4323 44.0795C81.4142 44.089 81.3943 44.0936 81.3749 44.0936Z",
    fill: "#C16810"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5497 25.5879C75.3143 26.7608 75.7707 29.539 75.7707 29.539C73.4489 32.7105 70.1953 30.4088 70.1953 30.4088C70.6074 29.713 70.8408 26.1473 70.8408 26.1473L75.5497 25.5879Z",
    fill: "url(#paint3_linear_3793_18422)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4118 16.1687C67.6504 16.0511 67.0019 19.57 69.3726 19.9937C71.7432 20.4171 72.0161 16.3424 69.4118 16.1687Z",
    fill: "url(#paint4_linear_3793_18422)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1239 16.0282C68.2007 15.9879 67.705 26.0718 71.4995 27.7361C75.2938 29.4004 77.5004 21.9125 76.9093 19.4401C76.3179 16.968 74.9822 16.0574 72.1239 16.0282Z",
    fill: "url(#paint5_linear_3793_18422)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5604 17.7461C70.52 18.7654 68.9262 18.4128 68.2706 16.7454C67.6151 15.0781 70.5044 13.1007 72.4284 15.0645C73.5072 14.403 74.3913 15.3055 74.7344 15.6556C75.8947 15.2471 76.9543 16.4562 76.6968 16.9579C77.9157 16.9705 77.8138 22.9605 75.6641 25.5024C75.9101 23.9912 74.8809 23.2171 74.8809 23.2171C75.5921 22.5202 75.7394 19.7822 74.3692 20.5073C73.9883 20.7089 73.9394 21.4277 73.9394 21.4277L73.4981 21.4231C73.4981 21.4231 73.9155 19.6619 73.5678 18.7123C73.2207 17.763 72.4652 17.6502 71.5604 17.7461Z",
    fill: "url(#paint6_linear_3793_18422)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.498 21.4231C73.2702 23.1443 72.6501 24.1679 72.2297 24.1636C71.8093 24.1593 71.0196 23.2895 70.3681 23.2827C69.7165 23.2762 69.0391 23.7525 69.0351 24.1309C69.0313 24.5092 68.4039 27.6764 69.4419 28.2197C70.4798 28.7627 73.4054 28.5105 73.9577 27.5362C74.51 26.562 73.7231 22.6866 73.9391 21.4276L73.498 21.4231Z",
    fill: "url(#paint7_linear_3793_18422)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3499 24.17C70.2175 24.1748 69.8623 24.1929 69.6957 24.287C69.4394 24.4315 69.5147 24.712 69.7037 24.8804C69.8628 25.0221 70.1699 25.0949 70.4126 25.0755C70.8262 25.0423 70.9773 24.9089 71.1324 24.609C71.192 24.4937 71.2162 24.2734 71.041 24.1911C70.9035 24.1267 70.641 24.1597 70.3499 24.17Z",
    fill: "#F4EEFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.16 49.1186C41.8038 48.7627 41.4078 48.7986 40.8796 49.0466C40.3515 49.2946 39.9223 49.4371 39.4822 49.4371C39.0422 49.4371 37.8673 48.8208 37.8673 48.8208L37.1211 50.5463C37.1211 50.5463 40.4157 52.6879 40.8638 52.992C41.3119 53.2961 41.9362 54.0725 42.2801 54.1442C42.6242 54.2162 44.8889 53.256 44.8489 52.2717C44.7449 51.9596 43.9567 51.2194 43.6247 50.8874C43.2926 50.5553 42.9925 50.2953 42.7924 50.1752C42.592 50.0551 42.16 49.1186 42.16 49.1186Z",
    fill: "url(#paint8_linear_3793_18422)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.255 48.8226C41.6989 48.8593 40.9185 49.5028 40.9185 49.895C40.9185 50.287 40.8865 51.0475 41.3185 51.0475C41.7505 51.0475 41.7747 50.3111 41.9668 50.1193C42.1588 49.9272 43.0231 50.2233 43.3672 50.6875C43.7114 51.1517 44.8477 52.272 44.8477 52.272C44.8477 52.272 46.8939 51.5137 47.5774 51.2008C47.5774 51.0968 46.107 48.9343 46.107 48.9343C44.5791 49.6098 42.9833 48.7747 42.255 48.8226Z",
    fill: "url(#paint9_linear_3793_18422)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3276 51.9009C39.0099 51.9875 38.7433 52.5572 39.1274 52.6611C39.5116 52.7651 39.9197 52.3412 39.7357 52.0771C39.5516 51.813 39.5038 51.853 39.3276 51.9009Z",
    fill: "url(#paint10_linear_3793_18422)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8998 52.3916C39.5277 52.4568 39.4977 53.1239 39.8998 53.394C40.3018 53.6642 41.3423 54.2961 41.6763 54.148C42.0104 54.0003 42.2825 53.8741 42.1086 53.598C41.9344 53.3218 40.584 52.2715 39.8998 52.3916Z",
    fill: "url(#paint11_linear_3793_18422)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5063 52.9217C44.4937 52.9217 44.4809 52.9184 44.4693 52.9111C43.781 52.4847 43.1643 51.914 42.6854 51.2609C42.6625 51.2297 42.6693 51.1856 42.7005 51.1627C42.732 51.1398 42.7758 51.1466 42.7987 51.1778C43.267 51.8165 43.8702 52.3746 44.5433 52.7918C44.5763 52.8122 44.5864 52.8555 44.566 52.8885C44.5529 52.9099 44.53 52.9217 44.5063 52.9217Z",
    fill: "#E07E58"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9217 53.4038C43.9096 53.4038 43.8972 53.4008 43.8859 53.394C43.2724 53.0328 42.7226 52.5492 42.2959 51.9953C42.2722 51.9646 42.2778 51.9206 42.3087 51.8969C42.3394 51.8732 42.3835 51.879 42.4072 51.9097C42.823 52.4492 43.359 52.9207 43.9574 53.2729C43.9909 53.2926 44.002 53.3356 43.9823 53.3691C43.9692 53.3915 43.9458 53.4038 43.9217 53.4038Z",
    fill: "#E07E58"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2791 53.8131C43.2675 53.8131 43.2559 53.8104 43.2451 53.8043C42.7257 53.5161 42.2602 53.1304 41.8987 52.6888C41.8741 52.6589 41.8786 52.6146 41.9086 52.5899C41.9385 52.5652 41.9828 52.5698 42.0075 52.5997C42.3577 53.0277 42.8093 53.4018 43.313 53.6815C43.347 53.7004 43.3594 53.7431 43.3405 53.7769C43.3276 53.8 43.3037 53.8131 43.2791 53.8131Z",
    fill: "#E07E58"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5698 53.9583C41.5627 53.9583 41.5554 53.9573 41.5484 53.9551C41.5114 53.9432 41.491 53.9037 41.5028 53.8667C41.5491 53.7222 41.5735 53.5721 41.5753 53.4206C41.5761 53.365 41.5738 53.3008 41.5519 53.2466C41.5322 53.1981 41.496 53.1616 41.4572 53.1512C41.4132 53.1397 41.355 53.1598 41.3095 53.2028C41.2649 53.2446 41.2327 53.301 41.1987 53.3609L41.1889 53.3783C41.1486 53.4483 41.0995 53.5278 41.0245 53.5822C41.0096 53.5928 40.9706 53.6175 40.925 53.6094C40.8994 53.6051 40.877 53.591 40.8624 53.5701C40.8372 53.5344 40.8452 53.4939 40.848 53.4805C40.8641 53.3974 40.8989 53.3227 40.9321 53.2507C40.9505 53.2106 40.9681 53.1729 40.9824 53.1344C40.9983 53.0918 41.0439 52.9468 40.9726 52.859C40.9328 52.8099 40.8576 52.7864 40.7853 52.8003C40.7169 52.8136 40.6489 52.8579 40.5937 52.9252C40.5374 52.9936 40.4988 53.0787 40.4686 53.1527L40.4626 53.1681C40.4346 53.2383 40.4032 53.3179 40.3367 53.3315C40.3057 53.338 40.2745 53.328 40.2506 53.304L40.2421 53.2955L40.237 53.2847C40.2229 53.2552 40.2267 53.2227 40.2421 53.1145C40.2564 53.0133 40.2763 52.8746 40.264 52.788C40.2418 52.6321 40.1683 52.5027 40.0628 52.4332C40.0303 52.4119 40.0215 52.3683 40.0429 52.3358C40.0643 52.3033 40.1079 52.2945 40.1401 52.3157C40.2793 52.4073 40.3752 52.5722 40.4032 52.7681C40.411 52.8242 40.409 52.8927 40.4029 52.9607C40.4261 52.9179 40.453 52.8751 40.4855 52.8355C40.5613 52.7432 40.6584 52.6815 40.7589 52.6621C40.8825 52.6379 41.0094 52.6805 41.0821 52.7698C41.1632 52.8695 41.175 53.0201 41.1146 53.1827C41.0985 53.2265 41.0789 53.2685 41.06 53.3093C41.0522 53.3259 41.0446 53.3423 41.0376 53.3584C41.0481 53.3418 41.058 53.3249 41.0678 53.3081L41.0776 53.2909C41.1154 53.2247 41.1544 53.1565 41.2143 53.1001C41.2969 53.0223 41.4013 52.9906 41.4942 53.015C41.5763 53.0367 41.647 53.1034 41.6833 53.1938C41.7145 53.2711 41.7178 53.3524 41.717 53.4221C41.715 53.5878 41.6883 53.7516 41.6377 53.9092C41.6269 53.9394 41.5995 53.9583 41.5698 53.9583Z",
    fill: "#E07E58"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7857 52.2843C44.7671 52.2843 44.7482 52.2767 44.7343 52.2621L43.5693 51.017C43.3993 50.8353 43.2234 50.6475 43.0273 50.4916C42.8113 50.3199 42.5932 50.2077 42.3795 50.1576C42.2781 50.1339 42.0908 50.1095 41.9757 50.2134C41.9007 50.2812 41.8712 50.3879 41.8398 50.5012C41.8284 50.5422 41.8166 50.5848 41.8025 50.6261C41.7338 50.8252 41.6001 51.0004 41.4264 51.1195C41.3944 51.1414 41.3509 51.1333 41.3287 51.1014C41.3068 51.0694 41.3149 51.0256 41.3469 51.0037C41.4959 50.9015 41.6104 50.7512 41.6696 50.5802C41.6824 50.5432 41.693 50.5047 41.7043 50.4639C41.7396 50.3363 41.7761 50.2044 41.8816 50.1092C42.0019 50.0005 42.1902 49.9693 42.4115 50.0209C42.6456 50.0755 42.882 50.1971 43.1146 50.3816C43.3188 50.5437 43.4983 50.7356 43.6717 50.9211L44.8368 52.1662C44.8632 52.1947 44.862 52.239 44.8335 52.2654C44.8202 52.278 44.8028 52.2843 44.7857 52.2843Z",
    fill: "#E07E58"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42223 25.1636C2.21353 26.5875 2.35476 28.1324 1.61237 29.3652C1.0686 30.2683 0.0893104 30.9195 -0.18912 31.9363C-0.519661 33.1437 0.260999 34.3684 0.31739 35.6188C0.405752 37.5812 -1.28698 39.3764 -0.931268 41.308C-0.53351 43.4685 2.17401 44.5195 2.79632 46.6264C3.07853 47.5813 2.89602 48.6668 3.37584 49.5391C3.75245 50.2238 4.4669 50.6435 4.99884 51.2162C5.68082 51.9506 6.04812 52.9203 6.63921 53.7296C7.23031 54.539 8.22219 55.2192 9.18562 54.9431C10.2885 54.6269 10.7031 53.3065 10.9068 52.1774C12.7317 42.0625 11.5447 31.5584 8.58067 21.717C7.98303 19.7325 6.39074 18.5875 4.75087 20.1453C3.41184 21.4177 2.69034 23.3332 2.42223 25.1636Z",
    fill: "url(#paint12_linear_3793_18422)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6567 18.4134C17.1605 18.6043 17.6765 18.8505 17.9799 19.2958C18.4955 20.0528 18.2452 21.1494 18.7704 21.8996C18.9715 22.1866 19.2666 22.3915 19.5183 22.6355C20.3841 23.4743 20.6967 24.8365 20.2839 25.9688C20.1927 26.2186 20.0699 26.4577 20.0077 26.716C19.8297 27.4566 20.1716 28.2109 20.4835 28.9059C20.7954 29.6008 21.0887 30.392 20.8188 31.1044C20.6446 31.5641 20.2569 31.9188 20.0855 32.3795C19.9 32.8782 19.9692 33.4912 19.6092 33.8832C19.4675 34.0375 19.2759 34.1349 19.0868 34.2253C18.5848 34.4647 18.0592 34.6787 17.5051 34.7253C17.0995 34.7595 16.6925 34.7029 16.2897 34.6465C15.6759 34.5606 15.0622 34.4745 14.4482 34.3887C14.2186 34.3565 13.9812 34.3217 13.7846 34.1986C13.4847 34.0111 13.3375 33.6579 13.2295 33.321C12.2832 30.3706 12.984 27.1626 12.6852 24.0785C12.5817 23.0103 12.3574 21.952 12.3443 20.879C12.3338 20.0163 12.4616 18.3691 13.2871 17.8349C13.6791 17.5812 14.3024 17.7841 14.72 17.8649C15.3796 17.9918 16.0284 18.1755 16.6567 18.4134Z",
    fill: "url(#paint13_linear_3793_18422)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8477 26.8005C11.87 28.9953 11.9901 32.964 11.9901 32.964C11.9901 32.964 16.3798 33.8358 16.3798 33.6556C16.3798 33.4751 15.7184 30.8894 15.5679 29.0554C15.4327 28.9202 10.8477 26.8005 10.8477 26.8005Z",
    fill: "url(#paint14_linear_3793_18422)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5797 34.3212C10.4505 33.7024 8.91282 35.3445 8.61425 40.4187C8.31568 45.4929 7.97457 49.7141 8.35848 50.9935C8.74214 52.2726 12.0682 61.8241 12.0682 61.8241L14.4135 61.014C14.4135 61.014 12.0465 51.3349 12.0465 49.5865C12.0465 47.8384 13.2368 41.6555 13.6205 39.566C14.0041 37.4766 14.0723 34.7549 12.5797 34.3212Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7434 32.0081C12.6303 32.4879 16.2676 32.5518 16.2676 32.5518C17.6506 35.3021 19.9964 36.368 20.977 38.884C22.4466 42.6541 18.6425 51.548 19.3779 54.8099H10.1889C11.2123 51.6331 8.14223 40.7393 8.9098 37.2318C9.67762 33.7245 11.7434 32.0081 11.7434 32.0081Z",
    fill: "url(#paint15_linear_3793_18422)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6837 54.1702C8.55494 55.8428 7.25216 58.6457 7.29394 64.4678C7.30477 65.9929 7.48527 72.7354 7.63154 75.0851C8.33516 86.4061 8.31729 99.0382 8.31729 99.0382C9.59641 99.4221 11.8352 99.0382 11.8352 99.0382L16.5101 69.8383L24.2434 98.8892C25.7146 98.8892 27.5695 98.2069 27.5695 98.2069C27.5695 98.2069 25.5228 80.1382 24.7552 75.9169C23.9877 71.6957 24.8192 61.3341 19.3825 54.8101C17.7192 54.8098 10.6837 54.1702 10.6837 54.1702Z",
    fill: "url(#paint16_linear_3793_18422)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7592 80.2927C14.7522 80.2927 14.7449 80.292 14.7376 80.2907C14.6709 80.2786 14.6268 80.2149 14.6386 80.1485C14.7527 79.5143 14.865 78.8955 14.9752 78.2891C15.9623 72.8501 16.742 68.5541 16.8787 63.5283C16.8807 63.4606 16.9298 63.4044 17.0045 63.4089C17.0723 63.411 17.1259 63.4671 17.1239 63.5348C16.9869 68.5795 16.2055 72.8839 15.2164 78.3332C15.1066 78.9394 14.9941 79.5584 14.8803 80.192C14.8692 80.2515 14.8176 80.2927 14.7592 80.2927Z",
    fill: "#C16810"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0592 48.3039C20.0477 48.3039 20.0363 48.3024 20.0247 48.2988C19.9595 48.2797 19.9225 48.2115 19.9417 48.1465C20.3382 46.8007 20.748 45.4088 20.9668 43.9995C21.2095 42.4334 21.1772 41.0159 20.8706 39.7861C20.5323 38.4262 19.838 37.1752 18.8624 36.168C18.8156 36.1194 18.8169 36.0419 18.8652 35.9948C18.9135 35.9477 18.9916 35.9487 19.0387 35.9976C20.0439 37.0355 20.7596 38.3252 21.1088 39.7267C21.4229 40.9882 21.4564 42.4385 21.2087 44.0371C20.9879 45.4622 20.5753 46.8621 20.1766 48.2155C20.1609 48.2691 20.1121 48.3039 20.0592 48.3039Z",
    fill: "#9E86E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2291 36.521C18.6911 38.6578 25.3128 44.264 26.4049 44.6733C27.7693 45.1851 38.0841 48.7556 38.0841 48.7556C38.0841 48.7556 37.5871 50.4604 37.2246 50.8229C35.6044 50.8229 26.4794 49.0438 24.6885 48.3299C23.3507 47.7967 14.9985 43.5503 11.7183 41.2863C9.39644 39.6837 9.61496 36.6248 11.0142 35.7207C12.3857 34.8343 13.3247 35.3456 15.2291 36.521Z",
    fill: "#754CC4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3371 19.3145C19.1455 22.6818 18.5119 27.8458 18.0633 29.0409C17.7232 29.9469 17.3015 30.2183 15.8583 29.7772C14.415 29.3362 9.40427 27.2215 8.60246 25.2974C7.80065 23.3731 7.23951 21.0482 9.00324 19.2842C10.7672 17.5205 13.2212 17.4435 15.3371 19.3145Z",
    fill: "url(#paint17_linear_3793_18422)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0154 17.7112C14.5938 16.9086 12.4865 16.565 10.8511 16.6196C9.26967 16.6722 8.86084 17.2218 8.51318 17.4725C7.93845 17.8869 7.69627 18.6562 7.10895 19.0527C6.75826 19.2894 6.3308 19.3626 5.9192 19.4719C5.54309 20.1561 5.23571 20.8784 5.00989 21.6288C4.58042 23.0565 4.43038 24.5514 4.57035 26.0359C4.70881 27.5043 5.20752 28.9493 5.8477 30.2702C6.90201 32.4451 7.6147 34.8467 8.99577 36.8234C9.2805 35.9468 10.4551 34.6544 11.0226 33.9281C11.2713 33.6099 11.546 33.3081 11.74 32.9538C12.5391 31.4967 11.7755 29.7282 11.4886 28.0914C11.409 27.6375 11.369 27.163 11.5009 26.7214C11.7393 25.9231 12.4998 25.3504 12.6881 24.5388C12.8022 24.0474 12.7083 23.4729 13.0355 23.089C13.5143 22.5271 14.4164 23.2231 15.1492 23.133C15.8274 23.0497 17.5161 22.6721 17.7195 21.7099C18.0586 20.1048 17.1913 18.3748 16.0154 17.7112Z",
    fill: "url(#paint18_linear_3793_18422)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2517 26.9426C18.1867 27.3628 18.1218 27.7293 17.6387 27.8096C17.1558 27.8902 16.3943 27.3358 16.2734 26.9426C16.6636 26.6654 18.1311 26.8263 18.2517 26.9426Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.2656,
    y: 44.4399,
    width: 1.66091,
    height: 0.332182,
    fill: "#98C155"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2656,
    y: 44.9382,
    width: 1.66091,
    height: 0.332182,
    fill: "#98C155"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2656,
    y: 45.8242,
    width: 0.830454,
    height: 0.332182,
    transform: "rotate(-90 67.2656 45.8242)",
    fill: "#98C155"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.082,
    y: 45.8242,
    width: 1.38409,
    height: 0.332182,
    transform: "rotate(-90 73.082 45.8242)",
    fill: "#98C155"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.2422,
    y: 45.8242,
    width: 1.38409,
    height: 0.332182,
    transform: "rotate(-90 74.2422 45.8242)",
    fill: "#98C155"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75.2383,
    y: 44.7722,
    width: 1.71627,
    height: 0.332182,
    transform: "rotate(180 75.2383 44.7722)",
    fill: "#98C155"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4258,
    y: 44.7722,
    width: 1.32873,
    height: 0.332182,
    transform: "rotate(180 70.4258 44.7722)",
    fill: "#98C155"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 71.0312,
    y: 45.7688,
    width: 1.32873,
    height: 0.332182,
    rx: 0.166091,
    transform: "rotate(-90 71.0312 45.7688)",
    fill: "#98C155"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4688 45.7688L72.4688 44.4401L72.8009 44.4401L72.8009 45.5794C72.8009 45.684 72.7161 45.7688 72.6115 45.7688L72.4688 45.7688Z",
    fill: "#98C155"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 72.582,
    y: 45.7688,
    width: 1.32873,
    height: 0.276818,
    transform: "rotate(180 72.582 45.7688)",
    fill: "#98C155"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4258 45.2151L70.4258 44.44L70.4422 44.44C70.6166 44.44 70.758 44.5814 70.758 44.7557L70.758 45.2151L70.4258 45.2151Z",
    fill: "#98C155"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M70.728 45.1597H69.6484L70.2851 45.8517H70.728L70.4235 45.4642C70.4328 45.4734 70.4789 45.4863 70.5896 45.4642C70.7003 45.442 70.728 45.2519 70.728 45.1597Z",
    fill: "#98C155",
    stroke: "#98C155",
    strokeWidth: 0.0631493
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.813 45.8083H76.2734L76.813 45.2532L77.0714 45.5307L76.813 45.8083Z",
    fill: "#91C642"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4572 45.2532L77.1797 45.5307L77.4572 45.8429H77.9714L77.4572 45.2532Z",
    fill: "#91C642"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7934 44.4553H76.2383L77.1403 45.4614L78.528 43.8308L77.1403 44.8022L76.7934 44.4553Z",
    fill: "#F55A2A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3828,
    y: 3.61353,
    width: 8.0239,
    height: 1.60478,
    fill: "#98C155"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3828,
    y: 6.02051,
    width: 8.0239,
    height: 1.60478,
    fill: "#98C155"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3828,
    y: 10.3005,
    width: 4.01195,
    height: 1.60478,
    transform: "rotate(-90 13.3828 10.3005)",
    fill: "#98C155"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4766,
    y: 10.3005,
    width: 6.68659,
    height: 1.60478,
    transform: "rotate(-90 41.4766 10.3005)",
    fill: "#98C155"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 47.082,
    y: 10.3005,
    width: 6.68659,
    height: 1.60478,
    transform: "rotate(-90 47.082 10.3005)",
    fill: "#98C155"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 51.8984,
    y: 5.21826,
    width: 8.29137,
    height: 1.60478,
    transform: "rotate(180 51.8984 5.21826)",
    fill: "#98C155"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6289,
    y: 5.21826,
    width: 6.41912,
    height: 1.60478,
    transform: "rotate(180 28.6289 5.21826)",
    fill: "#98C155"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5703,
    y: 10.033,
    width: 6.41912,
    height: 1.60478,
    rx: 0.80239,
    transform: "rotate(-90 31.5703 10.033)",
    fill: "#98C155"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5234 10.033L38.5234 3.61384L40.1282 3.61384L40.1282 9.11773C40.1282 9.6232 39.7185 10.033 39.213 10.033L38.5234 10.033Z",
    fill: "#98C155"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0625,
    y: 10.033,
    width: 6.41912,
    height: 1.33732,
    transform: "rotate(180 39.0625 10.033)",
    fill: "#98C155"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6289 7.35815L28.6289 3.61367L28.7083 3.61367C29.5508 3.61367 30.2337 4.2966 30.2337 5.13905L30.2337 7.35815L28.6289 7.35815Z",
    fill: "#98C155"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1023 7.09033H24.8867L27.9625 10.4336H30.1023L28.6312 8.56138C28.6758 8.60596 28.8987 8.66837 29.4336 8.56138C29.9685 8.4544 30.1023 7.5361 30.1023 7.09033Z",
    fill: "#98C155",
    stroke: "#98C155",
    strokeWidth: 0.305076
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4857 10.2243H56.8789L59.4857 7.54272L60.7337 8.88353L59.4857 10.2243Z",
    fill: "#91C642"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6025 7.54272L61.2617 8.88353L62.6025 10.3919H65.0865L62.6025 7.54272Z",
    fill: "#91C642"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4004 3.68796H56.7188L61.0764 8.54838L67.7804 0.671143L61.0764 5.36397L59.4004 3.68796Z",
    fill: "#F55A2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3793_18422",
    x1: 53.2676,
    y1: 38.9578,
    x2: 57.2369,
    y2: 43.6714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3793_18422",
    x1: 70.1118,
    y1: 74.8779,
    x2: 71.9894,
    y2: 59.4392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9571CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#6237C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3793_18422",
    x1: 76.566,
    y1: 54.4033,
    x2: 88.08,
    y2: 54.4033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3793_18422",
    x1: 73.532,
    y1: 25.7099,
    x2: 72.9528,
    y2: 30.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3793_18422",
    x1: 68.0365,
    y1: 18.7925,
    x2: 69.844,
    y2: 17.9608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#1A1248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3793_18422",
    x1: 72.8939,
    y1: 16.775,
    x2: 73.0176,
    y2: 25.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3793_18422",
    x1: 72.41,
    y1: 14.3647,
    x2: 74.237,
    y2: 28.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#1A1248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3793_18422",
    x1: 70.1603,
    y1: 14.6577,
    x2: 71.9873,
    y2: 28.6721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#1A1248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3793_18422",
    x1: 39.256,
    y1: 47.5905,
    x2: 41.169,
    y2: 51.8131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3793_18422",
    x1: 42.2002,
    y1: 48.2778,
    x2: 46.1696,
    y2: 52.9914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3793_18422",
    x1: 39.8309,
    y1: 52.2361,
    x2: 39.0446,
    y2: 52.2972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3793_18422",
    x1: 42.2546,
    y1: 53.1613,
    x2: 39.9855,
    y2: 53.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3793_18422",
    x1: 13.6563,
    y1: 18.4996,
    x2: 4.89374,
    y2: 43.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#1A1248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3793_18422",
    x1: 20.9251,
    y1: 26.2232,
    x2: 12.3437,
    y2: 26.2232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#1A1248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3793_18422",
    x1: 13.4469,
    y1: 32.4157,
    x2: 13.7475,
    y2: 28.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3793_18422",
    x1: 16.1418,
    y1: 28.5761,
    x2: 13.6687,
    y2: 54.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9571CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#6237C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3793_18422",
    x1: 37.7997,
    y1: 66.3331,
    x2: 11.2801,
    y2: 80.3295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#F2830B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3793_18422",
    x1: 16.0253,
    y1: 21.0668,
    x2: 10.7369,
    y2: 27.7923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA976E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3793_18422",
    x1: 12.7273,
    y1: 17.7717,
    x2: 3.78823,
    y2: 43.3119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#1A1248"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.4ad3dbc57fb4e7526887ce0d114a7c57.svg";
export { ForwardRef as ReactComponent };